import React from "react";
import GeneralSettingsIcon from "../../assets/icons/settings.svg2";
import BillingDetailsIcon from "../../assets/icons/invoice_history.svg2";
import SecuritySettingsIcon from "../../assets/icons/security.svg2";
import TimezonesIcon from "../../assets/icons/timezones.svg2";
import CustomersIcon from "../../assets/icons/customers.svg2";
import PageNavLinks from "../Common/PageNavLinks";
import InteractionsIcon from "../../assets/icons/interactions.svg2";

export default function InteractionsLinks() {
  return (
    <PageNavLinks
      pageName="interactions"
      links={[
        {
          label: "INTERACTIONS",
          Icon: InteractionsIcon,
          href: "/interactions",
        },
      ]}
    />
  );
}
